import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import pwp255Api, { FP620 } from '../../../services/pwp255Api';

export function usePWP255Navigation() {
  const [list, setList] = useState<FP620[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const fetchList = useCallback(async (p = 1): Promise<FP620[]> => {
    try {
      const res = await pwp255Api.list(p, 20);
      setList(res.data || []);
      setTotal(res.total);
      setPage(p);
      return res.data || [];
    } catch {
      message.error('載入列表失敗');
      return [];
    }
  }, []);

  useEffect(() => {
    fetchList(1);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const goFirst = useCallback((): string | null => {
    if (list.length > 0) {
      setCurrentIndex(0);
      return list[0].fp620_01;
    }
    return null;
  }, [list]);

  const goLast = useCallback((): string | null => {
    if (list.length > 0) {
      const idx = list.length - 1;
      setCurrentIndex(idx);
      return list[idx].fp620_01;
    }
    return null;
  }, [list]);

  const goPrev = useCallback((): string | null => {
    if (currentIndex > 0) {
      const idx = currentIndex - 1;
      setCurrentIndex(idx);
      return list[idx].fp620_01;
    }
    return null;
  }, [currentIndex, list]);

  const goNext = useCallback((): string | null => {
    if (currentIndex < list.length - 1) {
      const idx = currentIndex + 1;
      setCurrentIndex(idx);
      return list[idx].fp620_01;
    }
    return null;
  }, [currentIndex, list]);

  const setCurrentById = useCallback((id: string) => {
    const idx = list.findIndex(r => r.fp620_01 === id);
    if (idx >= 0) setCurrentIndex(idx);
  }, [list]);

  return {
    list, total, page, currentIndex,
    fetchList, goFirst, goLast, goPrev, goNext, setCurrentById,
    hasPrev: currentIndex > 0,
    hasNext: currentIndex < list.length - 1,
  };
}
